import { t } from "@lingui/core/macro";

import { Avatar } from "@whoosh/design-system/src/components/display";
import {
  Box,
  HStack,
  Text,
} from "@whoosh/design-system/src/components/primitive";

import type { PlayerDisplay } from "../types";

type PlayerRowProps = {
  player: PlayerDisplay;
  isOwner: boolean;
};

export const PlayerRow = ({ player, isOwner }: PlayerRowProps) => (
  <HStack alignItems="center" paddingVertical={2} gap={3}>
    <HStack alignItems="center" gap={3}>
      <Avatar
        size="xs"
        firstName={player.firstName ?? undefined}
        lastName={player.lastName ?? undefined}
        profileImagePublicId={player.profileImagePublicId ?? undefined}
      />
      <Text variant="mainBaseSemiBold" color="text-primary">
        {player.displayName}
      </Text>
    </HStack>
    {isOwner ? (
      <Box
        paddingHorizontal={1}
        borderWidth={1}
        borderColor="outline-default"
        borderRadius="1"
      >
        <Text variant="mainMicro">{t`OWNER`}</Text>
      </Box>
    ) : null}
  </HStack>
);
